module.exports = __webpack_public_path__ + "static/media/pic_selfie@2x.0519d942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_selfie@2x.jpg
// module id = 656
// module chunks = 0